<template>
  <div class="row">
    <div class="body-card">
      <div
        v-for="product in products"
        class="col-6 border-service">
        <course-item :item="product"/>
      </div>
    </div>
  </div>

</template>

<script>
  import rating from '../include/rating'
  import CourseItem from './CourseItem'
  import rf from '../../communicate/RequestFactory';

  export default {
    name: 'Course',
    components: {
      rating: rating,
      CourseItem: CourseItem,
    },

    props: ['product_name'],
    data () {
      return {
        products: [],
        errors: []
      }
    },

    mounted () {
      rf.getRequest('CourseRequest').getCourses().then((res) => {
        this.products = res.data;
      }).catch(err => {
        this.errors.push(err);
      })
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/course/Course.vue